import React, { useState,useEffect } from "react";
import "./DashboardTwoCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft, faL } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import next_test_lock from "../../images/not_atttend_test_lock.svg";
import not_attendt_lock from "../../images/next_test_lock.svg";
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";
import buttonloader from "../../images/buttonloader.gif";
import Subscriptions from "../Subscriptions/Subscriptions";

function DashboardTwoCard({onLoginChange,userdetail,token,handleNavigete,journey_data,HeaderTest}) {

  const navigator = useNavigate();
  const [showAllCore, setShowAllCore] = useState(false);
  const [showAllInsight, setShowAllInsight] = useState(false);

  const [activeNextContentInsight, setactiveNextContentInsight] = useState(null);
  const [activeIndexInsight, setactiveIndexInsight] = useState(null);

  const [activeNextContentCore, setactiveNextContentCore] = useState(null);

  const [CoreComplete, setCoreComplete] = useState(null);

  const [InsightComplete, setInsightComplete] = useState(null);

  const [activeIndexCore, setactiveIndexCore] = useState(null);

  const [showFreeSub,setshowFreeSub] = useState(false);


  const [TakeSubShow,setTakeSubShow] = useState(false);

  const [showPopup, setShowPopup] = useState(true);

  const [ShowModal, setShowModal] = useState(false);

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [freeSubContent, setFreeSubContent] = useState("");

  const handleNavigeteTest = (link) => {

      navigator(`/${link}`);
  }
    
  const TakeFreeSub = (type) => {

    console.log(type,'type');

    if (type === "dilemma") {
      setFreeSubContent(HeaderTest?.not_have_free_test_dilemma);
    } 
    else if (type === "special99999") {
      setFreeSubContent(HeaderTest?.not_have_free_test);
    } 
    else if (type === "special99998") {
      setFreeSubContent(HeaderTest?.not_have_free_test_pms);
    }

    setshowFreeSub(true);
  };

  
  const TakeSub = (type) => {

    console.log(type,'type');

    if (type === "dilemma") {
      setFreeSubContent(HeaderTest?.not_have_free_test_dilemma);
    } 
    else if (type === "special99999") {
      setFreeSubContent(HeaderTest?.not_have_free_test);
    } 
    else if (type === "special99998") {
      setFreeSubContent(HeaderTest?.not_have_free_test_pms);
    }

    setTakeSubShow(true);

  };

      const [ButtonLoad, setButtonLoad] = useState(false);

      const HandlePayment = (item) => {
  
        const InitializePayment = async () => {

            try {

                setButtonLoad(true);

                const pay_url = 'test-payment';

                const response = await fetch(`${END_URL}/${pay_url}`, {
        
                    method: "POST",
                    headers: {

                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(item)

                });

                const data = await response.json();

                console.log(data.payment, 'fetch data');

                if (data.payment) {

                    setButtonLoad(false);
                    window.location.href = data.payment;

                } else {

                    setButtonLoad(false);

                    console.error("Invalid response:", data);
                    alert("An error occurred while processing the request.");
                }

            } catch (error) {

                console.error("Error sending result:", error);
            }
        };

        InitializePayment();

    };


  const handleSub = async (subJson) => {
      try {
        let subIds = [];
  
        if (typeof subJson === "string") {
          try {

            subIds = JSON.parse(subJson);

          } catch (e) {

            console.error("Invalid JSON string for subIds:", e);
            return;
          }
        } else if (Array.isArray(subJson)) {
          subIds = subJson;
        }
  
        setShowPopup(false);
        setShowModal(true);
  
        const res = await axios.post(
          `${END_URL}/sub_adver`,
          { ids: subIds },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
  
        setSubscription(res.data);
  
        localStorage.removeItem("pendingSubIds");
      } catch (err) {
        console.error("Error loading subscriptions:", err);
      }
  };

  useEffect(() => {
    if (journey_data?.core?.tests) {

        const defaultIndex = journey_data.core.tests.findIndex(
          (t) => t.is_next_test
        );

       const defaultTest = journey_data.core.tests[defaultIndex];

      setactiveIndexCore(defaultIndex);

      setactiveNextContentCore(defaultTest?.next_test_content || null);
    }

    setCoreComplete(journey_data?.core?.allTestsCompleted);

  }, [journey_data]);

  useEffect(() => {
    if (journey_data?.insight?.tests) {

      const defaultIndex = journey_data.insight.tests.findIndex(
        (t) => t.is_next_test
      );

      const defaultTest = journey_data.insight.tests[defaultIndex];

      setactiveIndexInsight(defaultIndex);
      setactiveNextContentInsight(defaultTest?.next_test_content || null);
    }

    setInsightComplete(journey_data?.insight?.allTestsCompleted);

  }, [journey_data]);

  const handleTestClick = (item,index) => {

    setactiveIndexCore(index);

    if (item?.next_test_content) {
      setactiveNextContentCore(item.next_test_content);
    }
  };

  useEffect(() => {
    if (journey_data?.core?.tests?.length) {

      const firstNotAttended = journey_data.core.tests.findIndex(
        (t) => !t.is_attended
      );

      if (firstNotAttended !== -1) {
        setactiveIndexCore(firstNotAttended);
        setactiveNextContentCore(
          journey_data.core.tests[firstNotAttended]?.next_test_content || null
        );
      } else {

          setactiveIndexCore(0);
          setactiveNextContentCore(
            journey_data.core.tests[0]?.next_test_content || null
          );
      }
    }
  }, [journey_data]);


  const handleInsightClick = (item, index) => {

    setactiveIndexInsight(index);

    if (item?.next_test_content) {
      setactiveNextContentInsight(item.next_test_content);
    }
  };

  useEffect(() => {
    if (journey_data?.insight?.tests?.length) {

      const firstNotAttended = journey_data.insight.tests.findIndex(
        (t) => !t.is_attended
      );

      if (firstNotAttended !== -1) {
        setactiveIndexInsight(firstNotAttended);
        setactiveNextContentInsight(
          journey_data.insight.tests[firstNotAttended]?.next_test_content || null
        );
      } else {

          setactiveIndexInsight(0);
          setactiveNextContentInsight(
            journey_data.insight.tests[0]?.next_test_content || null
          );
      }
    }
  }, [journey_data]);

  const activeCoreTest =journey_data?.core?.tests?.[activeIndexCore] || null;

  const activeInsightTest = journey_data?.insight?.tests?.[activeIndexInsight] || null;

  const handleDoubleAction = (test) => {

      if (!test) return;

       if(test?.arche_tests_links !="" && test?.arche_tests_links != null)
        {
            handleNavigete(test?.arche_tests_links);
        }

      // const isDilemma = !!test?.dilemma;
      // const isSpecialTest = test?.id == 99998 || test?.id == 99999;

      // const freeTestType =
      //   isDilemma
      //     ? "dilemma"
      //     : test?.id == 99999
      //     ? "special99999"
      //     : test?.id == 99998
      //     ? "special99998"
      //     : null;

      // if (isDilemma && !HeaderTest?.user_attent_free_test) {
      //   TakeFreeSub(freeTestType);
      // }
      // else if (isSpecialTest) {
      //   if (
      //     HeaderTest?.user_attent_free_test &&
      //     HeaderTest?.user_have_free_test_sub
      //   ) {
      //     handleNavigete(test?.test_sub_links?.slug);

      //      if(test?.test_sub_links?.slug !="" && test?.test_sub_links?.slug != null)
      //       {
      //           handleNavigete(test?.test_sub_links?.slug);
      //       }
      //       else {

      //         handleSub(test?.sub_ids);
      //       }

      //   }
      //   else if (
      //     (!HeaderTest?.user_attent_free_test &&
      //       HeaderTest?.user_have_free_test_sub) ||
      //     userdetail?.user_all_access == 1
      //   ) {
      //     TakeFreeSub(freeTestType);
      //   }
      //   else {
      //     TakeSub(freeTestType);
      //   }
      // }
      // else if (test?.test_sub_links?.slug) {
      //   handleNavigete(test?.test_sub_links?.slug);
      // }
      // else {
      //   handleSub(test?.sub_ids);
      // }
    };

    



  return (
    <>
    <div className="dash-two-card-connt">
      <div className="row">

          <div className="col-md-6 core">
            <div className="two-card-box">

              <div             
                  style={{
                    backgroundImage: `url(${IMG_URL}/d0/${journey_data?.core?.journey_image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                  }}

                  className="two-card-img-cont core-data" dangerouslySetInnerHTML={{ __html:journey_data?.core?.description }}/>

              <div className="two-card-full-content">
              
                <div className="two-card-progress1">
                  
                  <h5>{journey_data?.core?.title}</h5>

                  <div className="progress-box">

                    <div
                      className="progress-bar-fill-repeat"
                      style={{ width: `${journey_data?.core?.completion_percentage}%` }}
                    ></div>
                  </div>

                </div>

                <div className="two-card-progress">
                  <div className="progress-bar-fill-repeat-title">
                    <span>{journey_data?.core?.attended_tests} of {journey_data?.core?.total_tests} steps complete</span>

                    <div>{journey_data?.core?.completion_percentage}% complete</div>

                  </div>

                  <div className="two-card-progress2">
                    <div
                      className="progress-bar-fill-repeat"
                      style={{ width: `${journey_data?.core?.completion_percentage}%` }}
                    ></div>
                  </div>
                </div>

                <div className="two-card-checkBoxs">

                  {journey_data?.core?.tests?.length > 0 && (
                      (showAllCore 
                        ? journey_data.core.tests 
                        : journey_data.core.tests.slice(0, 10)
                      ).map((item, index) => {

                         const showNext = item?.is_next_test;

                        const isActive = activeIndexCore === index;

                        const showNotAttended = !item?.is_attended && !isActive;

                        const showTake = item?.test_sub_links != null && item?.test_sub_links != "";

                        const showLock = item?.is_attended;

                        const showLockAttent = showTake || showLock;

                        const isDilemma = !!item?.dilemma;

                        const isUserAccess = userdetail?.user_all_access ==1;

                        const isSpecialTest = item?.id ==99998 ||  item?.id ==99999;

                        const RetakeTest = item?.isSpeacialTest;

                        const ShowRetakeTest = item?.is_attended && RetakeTest;

                        const past_link =  item?.have_mutiple ? isDilemma ? `dilemma-past-results/${item?.slug}` : `pastresults/${item?.slug}` : item?.speacial_test_link;

                        const freeTestType =
                                              isDilemma
                                                ? "dilemma"
                                                : item?.id == 99999
                                                ? "special99999"
                                                : item?.id == 99998
                                                ? "special99998"
                                                : null;

                        const unlocktrue = item?.is_attended && item?.test_complete;

                        return (

                          <div  onDoubleClick={() => handleDoubleAction(item)} onClick={() => handleTestClick(item,index)} className={`two-boxes-ck-label ${ShowRetakeTest ? 'two-btn-case' : ''} ${showTake || item?.is_attended && !item?.test_complete ? 'show-take' : ''} ${isActive ? 'is_next_test' : ''}  ${!item?.is_attended && !isActive ? 'not_attended' : ''} ${item?.is_attended ? item?.test_complete ? 'is_attended' : 'not_complete' : ''} ${item?.is_attended && !item?.test_complete ? 'unlock_bar' : ''} `} key={item.id || index}>

                            <input type="checkbox" id={`core_test_${item.id}`}  checked={item?.is_attended || false} readOnly />

                            <label htmlFor={`core_test_${item.id}`}>

                              {isActive && (

                                <span>Next:</span>

                              )}

                              {item.name}

                            </label>

                              { ( (!showLock &&  (showTake && (!isDilemma ||  (isDilemma && HeaderTest?.user_attent_free_test))) ) || (isUserAccess) ) && !unlocktrue && (

                                // <span onClick={ ((isDilemma || isSpecialTest) && !HeaderTest?.user_attent_free_test ) ? () => TakeFreeSub(freeTestType) : () => handleNavigete(item?.test_sub_links?.slug)}> Take</span>

                                  <span
                                          onClick={() =>
                                            (isDilemma && !HeaderTest?.user_attent_free_test)
                                              ? TakeFreeSub(freeTestType)

                                              : isSpecialTest
                                                ? (
                                                    HeaderTest?.user_attent_free_test && HeaderTest?.user_have_free_test_sub
                                                      ? handleNavigete(item?.test_sub_links?.slug)

                                                      : (!HeaderTest?.user_attent_free_test && HeaderTest?.user_have_free_test_sub) || isUserAccess
                                                        ? TakeFreeSub(freeTestType)

                                                        : TakeSub(freeTestType)
                                                  )

                                                : handleNavigete(item?.test_sub_links?.slug)
                                          }
                                        >
                                          Take
                                      </span>

                              )}

                              {item?.is_attended && RetakeTest && (

                                  <div className="group-completed" >

                                    <span className="see-result" onClick={() => handleNavigete(past_link) }>See Result</span>

                                   {showTake && (

                                      <span onClick={() => handleNavigete(item?.test_sub_links?.slug) }>Take Again</span>
                                      
                                   )}

                                  </div>
                              )}

                              {/* {item?.is_attended && !item?.test_complete && (

                                  <span onClick={() => handleSub(item?.sub_ids) }>Unlock Full Results</span>
                              )} */}
                                                
                              { !(item?.is_attended && item?.test_complete) && ((!showTake && !isDilemma) || (isDilemma && !HeaderTest?.user_attent_free_test) && !isUserAccess ) && (
                                  <img
                                    src={isActive ? next_test_lock : not_attendt_lock}
                                    alt=""
                                  />
                              )}

                          </div>

                        );

                      })
                  )}

                  {journey_data?.core?.tests?.length > 10 && (
                    <button onClick={() => setShowAllCore(!showAllCore)}>
                      {showAllCore ? "Show Less" : "See More"}
                    </button>
                  )}

                  <div className="two-boxes-bottom-contents next-test-content" dangerouslySetInnerHTML={{__html:activeNextContentCore || ""}} />
          
                </div>

                <div className="two-card-bottom-buttons">
                  
                      <a
                            onClick={() => {
                              const isDilemma = !!activeCoreTest?.dilemma;
                              const isSpecialTest =
                                activeCoreTest?.id == 99998 ||
                                activeCoreTest?.id == 99999;

                              const freeTestType =
                                isDilemma
                                  ? "dilemma"
                                  : activeCoreTest?.id == 99999
                                  ? "special99999"
                                  : activeCoreTest?.id == 99998
                                  ? "special99998"
                                  : null;

                              const Iscomplete = CoreComplete || InsightComplete;
                              if(Iscomplete)
                              {
                                handleSub(activeCoreTest?.sub_ids_default);
                              }
                              else if (isDilemma && !HeaderTest?.user_attent_free_test) {
                                TakeFreeSub(freeTestType);
                              }
                              else if (isSpecialTest) {

                                if (
                                  HeaderTest?.user_attent_free_test &&
                                  HeaderTest?.user_have_free_test_sub
                                ) {

                                    if(activeCoreTest?.test_sub_links?.slug !="" && activeCoreTest?.test_sub_links?.slug != null)
                                    {
                                        handleNavigete(activeCoreTest?.test_sub_links?.slug);
                                    }
                                    else {

                                      handleSub(activeCoreTest?.sub_ids);
                                    }

                                }
                                else if (
                                  (!HeaderTest?.user_attent_free_test &&
                                    HeaderTest?.user_have_free_test_sub) ||
                                  userdetail?.user_all_access == 1
                                ) {

                                  TakeFreeSub(freeTestType);
                                }
                                else {

                                  TakeSub(freeTestType);
                                }

                              }
                              else if(activeCoreTest?.test_sub_links?.slug !="" && activeCoreTest?.test_sub_links?.slug != null)
                              {
                                   handleNavigete(activeCoreTest?.test_sub_links?.slug);
                              }
                              else {

                                 handleSub(activeCoreTest?.sub_ids);
                              }
                            }}
                            className="continue-btn new-commom-btn"
                          >
                            <span>{journey_data?.core?.button_label}</span>

                            <span className="righ-arr">
                              <FontAwesomeIcon icon={faArrowRight} />
                            </span>
                        </a>


                  <button onClick={() => navigator(`/${journey_data?.core?.product_link}`)}>
                    See All Products
                  </button>

                </div>

              </div>

            </div>

          </div>

          <div className="col-md-6 insight">

            <div className="two-card-box">

              <div 

                style={{
                    backgroundImage: `url(${IMG_URL}/d0/${journey_data?.insight?.journey_image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                  }}
              
                className="two-card-img-cont core-data" dangerouslySetInnerHTML={{ __html:journey_data?.insight?.description }}/>

              <div className="two-card-full-content">

                <div className="two-card-progress1">
                  
                  <h5>{journey_data?.insight?.title}</h5>

                  <div className="progress-box">

                    <div
                      className="progress-bar-fill-repeat"
                      style={{ width: `${journey_data?.insight?.completion_percentage}%` }}
                    ></div>
                  </div>

                </div>

                <div className="two-card-progress">

                  <div className="progress-bar-fill-repeat-title">

                    <span>{journey_data?.insight?.attended_tests} of {journey_data?.insight?.total_tests} steps complete</span>

                    <div>{journey_data?.insight?.completion_percentage}% complete</div>

                  </div>
                  
                  <div className="two-card-progress2">
                    <div
                      className="progress-bar-fill-repeat"
                      style={{ width: `${journey_data?.insight?.completion_percentage}%` }}
                    ></div>
                  </div>
                </div>

                <div className="two-card-checkBoxs">

                  {journey_data?.insight?.tests?.length > 0 && (
                      (showAllInsight 
                        ? journey_data.insight.tests 
                        : journey_data.insight.tests.slice(0, 10)
                      ).map((item, index) => {

                         const showNext = item?.is_next_test;

                        const isActive = activeIndexInsight === index;

                        const showNotAttended = !item?.is_attended && !isActive;

                        const showTake = item?.test_sub_links != null && item?.test_sub_links != "";

                        const showLock = item?.is_attended;

                        const showLockAttent = showTake || showLock;

                        const isDilemma = !!item?.dilemma;

                        const isUserAccess = userdetail?.user_all_access ==1;

                        const isSpecialTest = item?.id ==99998 ||  item?.id ==99999;

                        const RetakeTest = item?.isSpeacialTest;

                        const freeTestType =
                                              isDilemma
                                                ? "dilemma"
                                                : item?.id == 99999
                                                ? "special99999"
                                                : item?.id == 99998
                                                ? "special99998"
                                                : null;


                        const unlocktrue = item?.is_attended && item?.test_complete;

                        const ShowRetakeTest = item?.is_attended && RetakeTest;

                        const past_link =  item?.have_mutiple ? isDilemma ? `dilemma-past-results/${item?.slug}` : `pastresults/${item?.slug}` : item?.speacial_test_link;

                        return (

                          <div  onDoubleClick={() => handleDoubleAction(item)} onClick={() => handleInsightClick(item,index)} className={`two-boxes-ck-label ${ShowRetakeTest ? 'two-btn-case' : ''} ${showTake || item?.is_attended && !item?.test_complete ? 'show-take' : ''} ${isActive ? 'is_next_test' : ''}  ${!item?.is_attended && !isActive ? 'not_attended' : ''} ${item?.is_attended ? item?.test_complete ? 'is_attended' : 'not_complete' : ''} ${item?.is_attended && !item?.test_complete ? 'unlock_bar' : ''} `} key={item.id || index}>

                            <input type="checkbox" id={`insight_test_${item.id}`} checked={item?.is_attended || false} readOnly />

                            <label htmlFor={`insight_test_${item.id}`}>

                               {isActive && (

                                <span>Next:</span>

                              )}
                              
                              {item.name}

                            </label>

                              { ( (!showLock &&  (showTake && (!isDilemma ||  (isDilemma && HeaderTest?.user_attent_free_test))) ) || (isUserAccess) ) && !unlocktrue && (

                                // <span onClick={((isDilemma || isSpecialTest) && !HeaderTest?.user_attent_free_test ) ? () => TakeFreeSub(freeTestType) : () => handleNavigete(item?.test_sub_links?.slug)}> Take</span>

                                <span
                                        onClick={() =>
                                          (isDilemma && !HeaderTest?.user_attent_free_test)
                                            ? TakeFreeSub(freeTestType)

                                            : isSpecialTest
                                              ? (
                                                  HeaderTest?.user_attent_free_test && HeaderTest?.user_have_free_test_sub
                                                    ? handleNavigete(item?.test_sub_links?.slug)

                                                    : (!HeaderTest?.user_attent_free_test && HeaderTest?.user_have_free_test_sub) || isUserAccess
                                                      ? TakeFreeSub(freeTestType)

                                                      : TakeSub(freeTestType)
                                                )

                                              : handleNavigete(item?.test_sub_links?.slug)
                                        }
                                      >
                                        Take
                                    </span>

                              )}

                              {item?.is_attended && RetakeTest && (

                                  <div className="group-completed" >

                                    <span className="see-result" onClick={() => handleNavigete(past_link) }>See Result</span>

                                    {showTake && (

                                        <span onClick={() => handleNavigete(item?.test_sub_links?.slug) }>Take Again</span>
                                    )}

                                  </div>
                              )}

                              {/* {item?.is_attended && !item?.test_complete && (

                                  <span onClick={() => handleSub(item?.sub_ids) }>Unlock Full Results</span>
                              )} */}

                            
                             { !(item?.is_attended && item?.test_complete) && ((!showTake && !isDilemma) || (isDilemma && !HeaderTest?.user_attent_free_test) && !isUserAccess ) && (
                                  <img
                                    src={isActive ? next_test_lock : not_attendt_lock}
                                    alt=""
                                  />
                              )}

                          </div>

                        );

                      })
                  )}

                  {journey_data?.insight?.tests?.length > 10 && (
                      <button onClick={() => setShowAllInsight(!showAllInsight)}>
                        {showAllInsight ? "Show Less" : "See More"}
                      </button>
                  )}

                   <div className="two-boxes-bottom-contents next-test-content" dangerouslySetInnerHTML={{__html:activeNextContentInsight || ""}} />

                </div>

                <div className="two-card-bottom-buttons">

                      <a
                            onClick={() => {
                              const isDilemma = !!activeInsightTest?.dilemma;
                              const isSpecialTest =
                                activeInsightTest?.id == 99998 ||
                                activeInsightTest?.id == 99999;

                              const freeTestType =
                                isDilemma
                                  ? "dilemma"
                                  : activeInsightTest?.id == 99999
                                  ? "special99999"
                                  : activeInsightTest?.id == 99998
                                  ? "special99998"
                                  : null;

                              const Iscomplete = CoreComplete || InsightComplete;
                              if(Iscomplete)
                              {
                                handleSub(activeCoreTest?.sub_ids_default);
                              }
                              else if (isDilemma && !HeaderTest?.user_attent_free_test) {
                                TakeFreeSub(freeTestType);
                              }
                              else if (isSpecialTest) {

                                if (
                                  HeaderTest?.user_attent_free_test &&
                                  HeaderTest?.user_have_free_test_sub
                                ) {

                                   if(activeInsightTest?.test_sub_links?.slug !="" && activeInsightTest?.test_sub_links?.slug != null)
                                    {
                                        handleNavigete(activeInsightTest?.test_sub_links?.slug);
                                    }
                                    else {

                                      handleSub(activeInsightTest?.sub_ids);
                                    }

                                }
                                else if (
                                  (!HeaderTest?.user_attent_free_test &&
                                    HeaderTest?.user_have_free_test_sub) ||
                                  userdetail?.user_all_access == 1
                                ) {
                                  TakeFreeSub(freeTestType);
                                }
                                else {
                                  TakeSub(freeTestType);
                                }

                              }
                              else if(activeInsightTest?.test_sub_links?.slug !="" && activeInsightTest?.test_sub_links?.slug != null)
                              {
                                   handleNavigete(activeInsightTest?.test_sub_links?.slug);
                              }
                              else {

                                 handleSub(activeInsightTest?.sub_ids);
                              }
                            }}
                            className="continue-btn new-commom-btn"
                          >
                            <span>{journey_data?.insight?.button_label}</span>

                            <span className="righ-arr">
                              <FontAwesomeIcon icon={faArrowRight} />
                            </span>
                        </a>
        

                  <button onClick={() => navigator(`/${journey_data?.insight?.product_link}`)}>
                    See All Products
                  </button>

                </div>

              </div>

            </div>

          </div>

    


      </div>
    </div>


      { showFreeSub  && (
    
            <div className={`newdashpop-overlay subs-cognit-modal1 dash-dil-12-pop`}>
                <div className="newdashpop-inner">
                    <div className="newdashpop-container  sub-no">
                        <button
                            className="newdashpop-close"
                            onClick={() => setshowFreeSub(false)}
                            >
                        &times;
                        </button>

                        <div className="conent-pop subs-left">
                            
                            <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html: freeSubContent}} />

                            <button   onClick={() => handleNavigeteTest(HeaderTest?.link)} >
                            
                                {HeaderTest?.not_have_free_test_label}

                            </button>

                        </div>

                    
                    </div>
                </div>
            </div>
      )}

         { TakeSubShow && (
                
              <div className={`newdashpop-overlay subs-cognit-modal1 dash-dil-12-pop`}>
                  <div className="newdashpop-inner">
                      <div className="newdashpop-container  sub-no">
                          <button
                              className="newdashpop-close"
                              onClick={() => setTakeSubShow(false)}
                              >
                          &times;
                          </button>
  
                          <div className="conent-pop subs-left">
                              
                              <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html: freeSubContent}} />

                              <button   onClick={() => HandlePayment(HeaderTest?.sub)} >
                              
                                  {HeaderTest?.not_have_free_test_label}

                                  <span>

                                      {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}
                                      
                                  </span> {ButtonLoad && <img  src={buttonloader} alt="Loading" />}
                          
                              </button>

                          </div>
  
                      
                      </div>
                  </div>
              </div>
          )}


       {ShowModal && (
          <div
            className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
              subscription?.data?.length == 1 ? "single-subscription" : ""
            }`}
          >
            <div className="newdashpop-inner">
              <div className="newdashpop-container">
                <button
                  className="newdashpop-close"
                  onClick={() => setShowModal(false)}
                >
                  &times;
                </button>

                <div className="conent-pop">
                  <Subscriptions
                    subs={subS}
                    userdetail={{ ...userdetail, user_all_access: "0" }}
                    force_to_disable={false}
                    Subcription={subscription}
                    onLoginChange={onLoginChange}
                    free_popup={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

    </>

  );
}

export default DashboardTwoCard;
